module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1026-63663ecd3880de7e1e92597295299f45.png";